import { Route, Routes } from "react-router-dom";
import { Dashboard } from "../Pages/Dashboard";
import { Community } from "../Pages/Community";
import { Survey } from "../Pages/Survey";
import { Selfcare } from "../Pages/Selfcare";
import { TherapySessions } from "../Pages/TherapySessions";
import { GroupSessions } from "../Pages/GroupSessions";
import { Login } from "../Pages/Login";
import { PrivateRoute } from "./PrivateRoute";
import { YogaSession } from "../Pages/YogaSession";
import { Employee } from "../Pages/Employee";
import { ArmyDashboard } from "../Pages/ArmyDashboard";

export const AllRoutes = () => {
  const userData =
    localStorage.getItem("userdata") || JSON.stringify({ image: "", tabs: [],accessCode :"" });
  const parsedUserData = JSON.parse(userData);
  const accessibleTabs = parsedUserData.tabs || [];
  const accessCode = parsedUserData.accessCode || "";
  // console.log("userdata",userdata);
  return (
    <Routes>
      <Route
        path="/"
        element={
          accessibleTabs.includes("all") ? (
            <PrivateRoute>
            {accessCode=== "army123" ? <ArmyDashboard /> : <Dashboard />}
            </PrivateRoute>
          ) : (
            <PrivateRoute>
              <YogaSession />
            </PrivateRoute>
          )
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/group-sessions"
        element={
          <PrivateRoute>
            <GroupSessions />
          </PrivateRoute>
        }
      />
       {/* <Route
        path="/army-dashboard"
        element={
          <PrivateRoute>
            <ArmyDashboard />
          </PrivateRoute>
        }
      /> */}
      <Route
        path="/therapy-sessions"
        element={
          <PrivateRoute>
            <TherapySessions />
          </PrivateRoute>
        }
      />
      <Route
        path="/self-care"
        element={
          <PrivateRoute>
            <Selfcare />
          </PrivateRoute>
        }
      />
      <Route
        path="/survey"
        element={
          <PrivateRoute>
            <Survey />
          </PrivateRoute>
        }
      />
      <Route
        path="/community"
        element={
          <PrivateRoute>
            <Community />
          </PrivateRoute>
        }
      />
      <Route
        path="/yoga-session"
        element={
          <PrivateRoute>
            <YogaSession />
          </PrivateRoute>
        }
      />
      <Route
        path="/employees"
        element={
          <PrivateRoute>
            <Employee />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
